// This is a "hacky" way to update the value of controlled <input />,
// making it compatible with controlled handlers, like formik. Based off:
// https://stackoverflow.com/a/46012210
export const forceInputValueChange = (input: HTMLInputElement, value: string) => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { set } = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')!;
  set!.call(input, value);
  const e = new Event('input', { bubbles: true });
  input.dispatchEvent(e);
};

export const generateImageSource = (src?: string | Record<string, string> | null) => {
  if (typeof src === 'string') {
    return [src, undefined] as const;
  }
  if (!src) {
    return [undefined, undefined] as const;
  }
  const sources = Object.keys(src).map((size) => `${src[size]} ${size}`);
  if (!sources.length) {
    return [undefined, undefined] as const;
  }
  const [source] = sources[0]!.split(' ');
  const sourceSet = sources.length > 1 ? sources.join(', ') : undefined;
  return [source, sourceSet] as const;
};

export const createScriptLoader = (id?: string) => {
  let scriptLoaded = false;
  let scriptFailed = false;
  let loadingPromise: Promise<void> | null = null;
  return (src: string) => {
    if (scriptLoaded) {
      return Promise.resolve(true);
    }

    if (scriptFailed) {
      return Promise.reject(false);
    }

    if (loadingPromise) {
      return loadingPromise;
    }

    loadingPromise = new Promise((resolve, reject) => {
      const scriptTag = document.createElement('script');
      if (id) {
        scriptTag.id = id;
      }
      scriptTag.src = src;
      document.body.appendChild(scriptTag);
      scriptTag.addEventListener('load', () => {
        scriptLoaded = true;
        resolve();
      });
      scriptTag.addEventListener('error', () => {
        scriptFailed = true;
        reject();
      });
    });
    return loadingPromise;
  };
};
